import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=059921be&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059921be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059921be')) {
      api.createRecord('059921be', component.options)
    } else {
      api.reload('059921be', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=059921be&scoped=true&", function () {
      api.rerender('059921be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dxNmz1L7zVeM/JS/comp/Accordion.vue"
export default component.exports